import React from 'react';
import { Thumbnail } from '@bynder/design-system';
import { IconFolder } from '@bynder/icons';
import { Category } from 'packages/store/categories/types';
import { hasPreviewImageURL, isProcessingDone } from '../../thumbnail/utils';

const CategoryOptionThumbnail = ({ category }: { category: Category }) => {
    if (category.coverImageUrl) {
        return (
            <Thumbnail
                size="xs"
                variant="content"
                imageUrl={category.coverImageUrl}
                backgroundColor={`#${category.coverBgColor}`}
            />
        );
    }

    if (category.coverBgColor) {
        return <Thumbnail size="xs" variant="content" backgroundColor={`#${category.coverBgColor}`} />;
    }

    if (hasPreviewImageURL(category) && isProcessingDone(category)) {
        return (
            <Thumbnail
                size="xs"
                variant="content"
                imageUrl={category.previewItems[category.previewItems.length - 1].previewUrl}
            />
        );
    }

    return (
        <Thumbnail size="xs" variant="clean" icon={<IconFolder />}>
            {!isProcessingDone(category) && <Thumbnail.Overlay isLoading={!isProcessingDone(category)} />}
        </Thumbnail>
    );
};

export default CategoryOptionThumbnail;
